import React, { useEffect, useRef } from 'react';
import { Empty, Typography } from 'antd';
import WorkspaceFeedItem from './WorkspaceFeedItem';

const { Paragraph } = Typography;

const WorkspaceFeed = ({
  items,
  emptyDescription,
  onPreviewFile,
  layout = 'default',
  onWorkspaceEventReply = null,
}) => {
  const containerRef = useRef(null);
  const initialised = useRef(false);
  const isRail = layout === 'rail';

  useEffect(() => {
    if (!containerRef.current) return;
    if (!items.length) return;
    if (!initialised.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
      initialised.current = true;
    } else {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [items.length]);

  if (!items.length) {
    const empty = (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        styles={{ image: { height: 56 } }}
        description={<Paragraph type="secondary" style={{ marginBottom: 0 }}>{emptyDescription}</Paragraph>}
      />
    );
    if (isRail) {
      return (
        <div className="workspace-feed workspace-feed--rail workspace-feed--rail-empty">
          {empty}
        </div>
      );
    }
    return empty;
  }

  return (
    <div
      ref={containerRef}
      className={isRail ? 'workspace-feed workspace-feed--rail' : undefined}
      style={
        isRail
          ? undefined
          : {
              maxHeight: 480,
              overflowY: 'auto',
              paddingRight: 4,
              marginBottom: 'var(--ant-margin-sm)',
            }
      }
    >
      {items.map((row, idx) => (
        <WorkspaceFeedItem
          key={`${row.kind}-${row.data?.id ?? idx}`}
          item={row}
          onPreviewFile={onPreviewFile}
          onWorkspaceEventReply={onWorkspaceEventReply}
        />
      ))}
    </div>
  );
};

export default WorkspaceFeed;
